import React from 'react';

const ManageQuests = () => {
  return (
    <div className="page-content">
      <h2>Manage Quests</h2>
      <p>This is a dummy page for managing quests.</p>
    </div>
  );
};

export default ManageQuests;
